/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Vekn_Sponsor_To_Register_MessageInputs */



/**
* | output |
* | --- |
* | "{name} doesn't have a VEKN ID. Sponsor them to register?" |
*
* @param {Vekn_Sponsor_To_Register_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_sponsor_to_register_message = /** @type {((inputs: Vekn_Sponsor_To_Register_MessageInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Sponsor_To_Register_MessageInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} n'a pas d'identifiant VEKN. Le parrainer pour l'inscrire ?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.name} no tiene ID de VEKN. ¿Patrocinarlo para inscribirlo?`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.name} não tem ID VEKN. Patrociná-lo para inscrevê-lo?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.name} non ha un ID VEKN. Sponsorizzarlo per iscriverlo?`)
	return /** @type {LocalizedString} */ (`${i?.name} doesn't have a VEKN ID. Sponsor them to register?`)
});